import '../assets/css/ChallengeSection.css';
import 'bootstrap/dist/css/bootstrap.min.css'; 
// import Roll from 'react-reveal/Roll';
// import Slide from 'react-reveal/Slide';
import Rotate from 'react-reveal/Rotate';

function ChallengeSection() {
    return (
            <div class="ChallengeSec container">
                     <div>
                <h2>Challenges</h2>
               
                {/* <Slide left> */}
                <Rotate top left>
                <div>
                <div class="row">
                    <div class="ChallengeDiv div1 col border p-0 m-2" style={{height:300}}>
                        <div class="ChallengeDivIn">
                        <a href="/designs">
                            <div>
                                <h1>30 Days Design Challenge</h1>
                                <p>Herosection</p>
                            </div>
                        </a>
                        </div>
                    </div>
                    <div class="ChallengeDiv div1 col border p-0 m-2" style={{height:300}}>
                        <div class="ChallengeDivIn">
                        <a href="/htmlcss">
                            <div>
                                <h1>Html Css Challenge</h1>
                                <p>All shapes are made using HTML CSS only</p>
                            </div>
                        </a>
                        </div>
                    </div>
                    <div class="ChallengeDiv div1 col border p-0 m-2" style={{height:300}}>
                        <div class="ChallengeDivIn">
                        <a href="/figma">
                            <div>
                                <h1>Figma practice</h1>
                                <p>UI / Animations Prototypes</p>
                            </div>
                        </a>
                        </div>
                    </div>
                </div>
                </div>
                </Rotate>
                {/* </Slide> */}
                {/* <Flip left>
                <div className="button">
                    <button>Show me more</button>
                </div>
                </Flip> */}
                </div>
            </div>
        );
    }
    
export default ChallengeSection;